import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    cardHeaderOverlay: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        position: "absolute",
        right: 0,
        left: 0,
        top: 0
    },
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    cardActionsOverlay: {
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center",
        position: "absolute",
        bottom: 0,
        right: 0,
        left: 0
    },
    lightboxImageContainer: {
        justifyContent: "center",
        alignItems: "center",
        maxHeight: "90%",
        maxWidth: "90%"
    },
    lightboxModalBackdrop: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    iconActionButton: {
        justifyContent: "center",
        alignItems: "center"
    },
    makeCoverButton: {
        justifyContent: "center",
        alignItems: "center"
    },
    emptyContainer: {
        justifyContent: "center",
        borderStyle: "dashed",
        alignItems: "center",
        width: "100%"
    },
    actionButton: {
        justifyContent: "center",
        alignItems: "center"
    },
    coverBadge: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    orderBadge: {
        justifyContent: "center",
        alignItems: "center"
    },
    titleContainer: {
        flexDirection: "column"
    },
    headerActionsContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    lightboxCloseButton: {
        position: "absolute",
        zIndex: 100
    },
    gridContainer: {
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    cardContainer: {
        position: "relative",
        overflow: "hidden",
        aspectRatio: 4 / 5,
        width: "100%"
    },
    emptyDescText: {
        textAlign: "center"
    },
    makeCoverText: {
        fontWeight: "bold",
        fontSize: 10
    },
    orderBadgeText: {
        fontWeight: "bold"
    },
    headerActionButton: {
        height: 38
    },
    emptyTitleText: {
        fontWeight: "600"
    },
    coverBadgeText: {
        fontWeight: "600"
    },
    lightboxImage: {
        maxHeight: 600,
        maxWidth: 800,
        height: 500,
        width: 600
    },
    hiddenInput: {
        display: "none"
    },
    cardImage: {
        height: "100%",
        width: "100%"
    },
    dragActiveCard: {
        opacity: 0.4
    },
    cardWrapper: {
        minWidth: 150
    },
    container: {
        width: "100%"
    }
});
export default stylesheet;
